<template>
	<div class="container">
		<div class="main_box">
			<!--导航-->
			<navBox></navBox>
			<!--导航-->
			<!--banner-->
			<div class="banner_box"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<img src="../../assets/img_public/products/h5_banner01.webp" />
			</div>
			<!--banner-->
			<!--块1-->
			<div ref="myElement" class="block_1">
				<div class="top_box"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="tit_box">
						<div class="left">{{ $t('product.text0') }}</div>
						<div class="right">
							<span @click="filterShow = true;">{{ $t('product.text7') }}</span>
							<span @click="reloadList">{{ $t('product.text8') }}</span>
						</div>
					</div>
					<div class="search_box">
						<van-icon name="search" size="20px" style="top: -1px;" />
						<input v-model="inputVal" :placeholder="$t('product.text9')" />
						<div class="tit" @click="searchClick">{{ $t('product.text10') }}</div>
					</div>
				</div>
				<div v-if="listData.length > 0">
					<div class="list_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div v-for="(value, index) in listData" :key="index" class="list_el" @click="goInfo(value)">
							<div class="tit">
								{{ value.name }}
							</div>
							<div class="list_bot">
								<div class="left">
									<img :src="webUrl + value.thumb" />
								</div>
								<div class="right">
									{{ value.description }}
								</div>
							</div>
						</div>
					</div>
					<div class="page_box">
						<el-pagination
							:small="false"
							background
							layout="prev, pager, next"
							:total="total"
							:page-size="10"
							:pager-count="5"
							@current-change="pageChange"
						>
						</el-pagination>
					</div>
				</div>
				<div v-else
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<van-empty image="search" description="暂无数据~" />
				</div>
			</div>
			<!--块1-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
			<van-popup
				v-model="filterShow"
				position="bottom"
				round
				close-on-click-overlay
				:closeable="false"
				:style="{ width: '100%', height: '85%' }"
			>
				<div class="filter_box">
					<div class="top_box">
						<div class="tit_box">
							<div class="left">{{ $t('product.text11') }}</div>
							<div class="right">
								<span @click="reloadFilter">{{ $t('product.text14') }}</span>
								<span style="color: #A20073;" @click="filterYes">{{ $t('product.text15') }}</span>
							</div>
						</div>
						<div class="cate_box">
							<div :class="isFilterTitle == 1 ? 'actived' : ''" @click="checkFilter(1)">{{ $t('product.text12') }}</div>
							<div :class="isFilterTitle == 2 ? 'actived' : ''" @click="checkFilter(2)">{{ $t('product.text13') }}</div>
						</div>
					</div>
					<div v-if="filterList.length > 0" class="filter_list"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div v-for="(value1, index1) in filterList" :key="index1" class="filter_el">
							<div class="title">{{ value1.title }}</div>
							<div v-if="value1.children.length > 0" class="check_box">
								<div v-for="(value2, index2) in value1.children" :key="index2" class="check_el" :class="value2.is_checked == 1 ? 'actived' : ''" @click="checkChildClick(value2, value1)">{{ value2.title }}</div>
								<div class="check_all" @click="checkClick(value1)">{{ value1.is_checked == 1 ? '取消全选' : '全选' }}</div>
							</div>
							<div v-if="value1.children.length > 0" class="check_boy_box">
								<div v-for="(value2, index2) in value1.children" :key="index2">
									<div v-if="value2.children.length > 0" class="check_boy">
										<div v-if="value2.children.length > 0" class="tit">{{ value2.title }}</div>
										<div v-if="value2.children.length > 0" class="check_box">
											<div v-for="(value3, index3) in value2.children" :key="index3" class="check_el" :class="value3.is_checked == 1 ? 'actived' : ''" @click="checkElClick(value3, value2)">{{ value3.title }}</div>
											<div class="check_all" @click="checkChildClick2(value2)">{{ value2.is_checked2 == 1 ? '取消全选' : '全选' }}</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</van-popup>
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navBox from '@/component/h5/nav.vue'  //导航组件
import footerBox from '@/component/h5/footer.vue'  //版权组件
import { UPURL } from '@/util/util';
import { productSelectList, productList, productInfo } from '@/api/public'
export default {
	components:{
		navBox,
		footerBox
	},
	data() {
		return {
			isLoading: true,  //界面loading
			filterShow: false,  //筛选弹框
			checked: false,
			listData: [],
			page: 1,
			total: 0,
			webUrl: UPURL,
			inputVal: '',
			scenarios_list: [],  //应用场景
			cate_list: [],  //产品分类
			cert_list: [],  //产品认证
			filterList: [],
			isFilterTitle: null,
			scenariosIds: '',
			cateIds: '',
			certIds: '',
			lang: sessionStorage.getItem('lang'),
		}
	},
	created(){
		let that = this;
		if(that.$route.query.scenarios_ids) {
			that.scenariosIds = that.$route.query.scenarios_ids;
		}
		if(that.$route.query.cate_ids) {
			that.cateIds = that.$route.query.cate_ids;
		}
		if(that.$route.query.cert_ids) {
			that.certIds = that.$route.query.cert_ids;
		}
		//请求产品数据
		that.getList();
		//请求产品分类
		that.getProductSelectList();
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		//子项父点击
		checkChildClick2(value) {
			let that = this;
			value.is_checked2 = !value.is_checked2;
			if(value.is_checked2) {
				 if(value.children.length > 0) {
				 	value.children.forEach((value, index) => {
						value.is_checked = 1;
					});
				}
			}else {
				if(value.children.length > 0) {
					value.children.forEach((value, index) => {
						value.is_checked = 0;
					});
				}
			}
		},
		//子项点击
		checkElClick(value1, value2) {
			let that = this;
			if(value1.is_checked) {
				value1.is_checked = 0;
			}else {
				value1.is_checked = 1;
			}
		},
		//子复选框点击
		checkChildClick(value1, value2) {
			let that = this;
			if(value1.is_checked) {
				value1.is_checked = 0;
			}else {
				value1.is_checked = 1;
			}
		},
		//复选框点击
		checkClick(value) {
			let that = this;
			value.is_checked = !value.is_checked;
			if(value.is_checked) {
				if(value.children.length > 0) {
					value.children.forEach((value1, index1) => {
						value1.is_checked = 1;
					});
				}
			}else {
				if(value.children.length > 0) {
					value.children.forEach((value1, index1) => {
						value1.is_checked = 0;
					});
				}
			}
		},
		//清除条件
		reloadFilter() {
			let that = this;
			that.scenariosIds = '';
			that.cateIds = '';
			that.certIds = '';
			that.getProductSelectList();
		},
		//重置筛选
		reloadList() {
			let that = this;
			that.page = 1;
			that.scenariosIds = '';
			that.cateIds = '';
			that.certIds = '';
			that.getProductSelectList();
			that.getList();
		},
		//产品分类
		getProductSelectList() {
			let that = this;
			that.$toast.loading({ message: '', forbidClick: true, duration: 0 });
			productSelectList({
				scenarios_ids: that.scenariosIds,
				cate_ids: that.cateIds,
				cert_ids: that.certIds,
				language: that.lang,
			}).then(res => {
				that.scenarios_list = res.data.scenarios_list;
				that.cate_list = res.data.cate_list;
				that.cert_list = res.data.cert_list;
				if(that.lang == 'cn') {
					that.isFilterTitle = 1;
					that.filterList = that.scenarios_list;
				}else if(that.lang == 'en'){
					that.isFilterTitle = 2;
					that.filterList = that.cate_list;
				}
				that.$toast.clear();
				// console.log(that.filterList);
			});
		},
		initArray(data) {
			let ids = [];
			data.forEach((value1, index1) => {
				if(value1.children.length > 0) {
					// console.log(value1.title);
					value1.children.forEach((value2, index2) => {
						if(value2.is_checked) { ids.push(value2.id); } 
						if(value2.children.length > 0) {
							value2.children.forEach((value3, index3) => {
								if(value3.is_checked) { ids.push(value3.id); } 
							});
						}
					});
				}
			});
			return ids.join(',');
		},
		//筛选确定
		filterYes() {
			let that = this;
			that.scenariosIds = that.initArray(that.scenarios_list);
			that.cateIds = that.initArray(that.cate_list);
			that.certIds = that.initArray(that.cert_list);
			// console.log(that.scenariosIds);
			// console.log(that.cateIds);
			// console.log(that.certIds);
			that.filterShow = false;
			that.page = 1;
			that.getList();
		},
		//筛选条件切换
		checkFilter(value) {
			let that = this;
			that.filterList = [];
			that.$nextTick(() => {
				switch(value) {
					case 1:
						that.isFilterTitle = 1;
						that.filterList = that.scenarios_list;
					break;
					case 2:
						that.isFilterTitle = 2;
						that.filterList = that.cate_list;
					break;
					case 3:
						that.isFilterTitle = 3;
						that.filterList = that.cert_list;
					break;
				}
			});
			
		},
		//点击搜索
		searchClick() {
			let that = this;
			that.page = 1;
			that.getList();
		},
		//分页点击
		pageChange(val) {
			let that = this;
			that.page = val;
			that.getList(true);
		},
		//获取列表
		getList(type) {
			let that = this;
			that.$toast.loading({ message: '', forbidClick: true, duration: 0 });
			productList({
				keyword: that.inputVal,
				cate_id: that.cateIds,
				scenarios_id: that.scenariosIds,
				cert_id: that.certIds,
				page: that.page,
				page_size: 10,
				language: sessionStorage.getItem('lang')
			}).then(res => {
				that.listData = res.data.data;
				that.total = res.data.total;
				that.listLoading = false;
				that.$toast.clear();
				if(type) {
					//滚动到列表顶部
					that.$refs.myElement.scrollIntoView({ behavior: 'smooth' });
				}
			});
		},
		//点击查看详情
		goInfo(value) {
			let that = this;
			that.$router.push({ name: 'ProductInfo', params: { productInfoId: value.id + '.html' } });
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	//筛选弹框
	.filter_box{
		padding: 30px 16px;
		.filter_list{
			padding-top: 10px;
			.filter_el{
				padding: 20px 0 0 0;
				.check_boy_box{
					.check_boy{
						padding: 0px 0 0 0;
						.tit{
							font-weight: bold;
							font-size: 16px;
						}
						.check_box{
							padding: 8px 0;
						}
					}
				}
				.check_box{
					position: relative;
					padding: 15px 0;
					.check_el{
						display: inline-block;
						margin: 5px 10px 5px 0;
						padding: 4px 12px;
						border-radius: 8px;
						background-color: #F7F6F9;
					}
					.check_el.actived{
						background-color: #A20073;
						color: #ffffff;
					}
					.check_all{
						display: inline-block;
					}
				}
				.title{
					position: relative;
					padding: 5px 0 0 10px;
					font-size: 18px;
					font-weight: bold;
					border-left: 2px solid #A50073;
					line-height: 0.8;
				}
			}
		}
		.top_box{
			border-bottom: 1px solid #E3E1E6;
			.cate_box{
				padding: 25px 0 0px 0;
				div{
					display: inline-block;
					margin-right: 28px;
					padding-bottom: 10px;
					font-size: 18px;
				}
				div.actived{
					color: #A20073;
					font-weight: bold;
					border-bottom: 1px solid #A20073;
				}
			}
			.tit_box{
				display: flex;
				align-items: center;
				.right{
					span{
						display: inline-block;
						margin-left: 20px;
						font-size: 16px;
					}
				}
				.left{
					flex: 1;
					font-size: 16px;
				}
			}
		}
	}
	//块1
	.block_1{
		padding: 40px 20px 0 20px;
		background: url(../../assets/img_public/products/block03.webp) no-repeat 100% 100%;
		background-size: cover;
		.page_box{
			padding-bottom: 40px;
			text-align: center;
		}
		.list_box{
			padding-bottom: 40px;
			.list_el{
				margin-bottom: 12px;
				padding: 16px 16px 20px 16px;
				background-color: #ffffff;
				border-radius: 8px;
				.list_bot{
					display: flex;
					align-items: center;
					padding-top: 6px;
					.right{
						flex: 0.7;
						padding-left: 12px;
						font-size: 12px;
						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-line-clamp: 4;
						-webkit-box-orient: vertical;
					}
					.left{
						flex: 0.3;
						img{
							width: 100%;
						}
					}
				}
				.tit{
					font-size: 16px;
					font-weight: bold;
				}
			}
		}
		.top_box{
			.search_box{
				position: relative;
				margin: 15px 0 24px 0;
				padding: 0 24px 0 16px;
				background-color: #ffffff;
				border: 1px solid #A50073;
				border-radius: 8px;
				display: flex;
				align-items: center;
				input{
					flex: 1;
					height: 38px;
					color: #A50073;
					border: none;
					padding: 0px 5px;
					user-select: none;
				}
				.tit{
					width: auto;
					font-size: 16px;
					line-height: 1;
					color: #A50073;
				}
			}
			.tit_box{
				display: flex;
				align-items: center;
				.right{
					flex: 1;
					text-align: right;
					span{
						display: inline-block;
						margin-left: 20px;
					}
				}
				.left{
					width: auto;
					font-size: 24px;
					font-weight: bold;
				}
			}
		}
	}
	//轮播
	.banner_box{
		img{
			width: 100%;
		}
	}
}
</style>
<style scoped>
/*分页*/
>>> .page_box .el-pagination {
  max-width: 100%; /* 最大宽度为屏幕宽度 */
}

>>> .page_box .el-pager li:hover{
	color: #A50073 !important;
}
>>> .page_box .el-pagination.is-background .el-pager li:not(.disabled).active{
	background-color: #A50073 !important;
}
>>> .page_box .el-pagination.is-background .el-pager li:not(.disabled).active:hover{
	color: #ffffff !important;
}
</style>